<template>
  <div class="col-12 p-0 m-0">
    <div class="position-relative flex-wrap m-0 mt-2 w-100" ref="supplierProductSku">
      <input @change="handleFindSkuInVendor" :value="mapping.product_sku" class="form-control col-12" placeholder="Product Sku" />
    </div>
    <div class="mapping-product flex-wrap m-0 mt-2" ref="product" style="display: none">
      <div class="products col-12 pl-0 pr-0 m-0">
        <div class="checkmark d-flex">
          <div class="thumbnail">
            <img :src="storeProduct.thumbnail" />
          </div>
          <div class="item-meta">
            <p class="title">{{ storeProduct.title }}</p>
            <ul class="attributes mb-0">
              <li v-for="(attribute, index) in storeProduct.attributes" :key="index">
                <label>{{ index }}:</label>
                <span>{{ Object.values(attribute).join(', ') }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      storeProduct: []
    }
  },
  created() {
    setTimeout(() => {
      this.$emit('changeValue', {
        is_valid: 1,
        store_id: '',
        product_sku: '',
        product_id: ''
      })
    }, 200)
  },
  computed: {
    storeId() {
      return this.config?.storeId
    },
    data() {
      return this.config?.data
    },
    mapping() {
      return this.config?.mapping
    }
  },
  methods: {
    handleFindSkuInVendor(e) {
      if (this.mapping.vendor_id && e.currentTarget.value != '') {
        this.$emit('changeValue', {
          product_id: '',
          product_sku: e.currentTarget.value
        })
        this.$util.get(
          `vendor-account/${this.mapping.vendor_id}/product-sku-in-vendor-account`,
          {
            store_id: this.mapping.store_id,
            search: e.currentTarget.value,
            page: 1
          },
          this.$refs.supplierProductId,
          {
            done: (response) => {
              if (response.status == 'success') {
                this.storeProduct = response.data
                this.$refs.product.style.display = 'block'
                this.$emit('changeValue', {
                  is_valid: this.checkIsValidProduct(this.storeProduct)
                })
              } else {
                this.$refs.product.style.display = 'none'
              }
            },
            error: () => {
              this.$refs.product.style.display = 'none'
            }
          }
        )
      } else {
        alert('Supplier and store are required')
      }
    },
    checkIsValidProduct(product) {
      if (_.isUndefined(product.attributes)) {
        return true
      }
      for (const [key, value] of Object.entries(product.attributes)) {
        if (_.isUndefined(this.data?.attributes?.[key])) {
          return false
        }
        let originAttribute = Object.values(value).map((item) => item.replace(/\s\s+/gi, ' ').trim().toUpperCase())
        let compareAttribute = Object.values(this.data.attributes[key]).map((item) => item.replace(/\s\s+/gi, ' ').trim().toUpperCase())
        if (originAttribute.filter((x) => compareAttribute.includes(x)).length == 0) {
          return false
        }
      }
      return true
    }
  },
  props: {
    config: Object
  }
}
</script>
